import { environmentConfig } from "@src/appV2/environment";
import { isCapacitorPlatform } from "@src/appV2/lib/utils/capacitor/platformUtils";

import { getAppUrl } from "./getAppUrl";

const AUTH_REDIRECT_PATH = "/auth/redirect";

/**
 * Returns the magic link redirect URL.
 * On native apps, uses the Firebase dynamic link domain (cbh.care in production)
 * because the native app is configured to handle that domain via deep links,
 * whereas the default web app hostname (hcp.clipboard.health) is not routable
 * back to the native app.
 */
export const getMagicLinkRedirectUrl = (): string => {
  if (isCapacitorPlatform()) {
    const dynamicLinkDomain = environmentConfig.REACT_APP_FIREBASE_DYNAMIC_LINK_DOMAIN;
    return `https://${dynamicLinkDomain}${AUTH_REDIRECT_PATH}`;
  }

  return `${getAppUrl()}${AUTH_REDIRECT_PATH}`;
};
